import {
  Backdrop,
  Box,
  Button,
  IconButton,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../Components/Loader";
import CloseIcon from "@mui/icons-material/Close";
import { updateRequestAction } from "../../../../store/actions/requests";
import SelectInput from "../../../../Components/SelectInput/index";
import { useFormik } from "formik";
import { getCategoriesAction } from "../../../../store/actions/categories";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1,
  maxWidth: "686px",
  boxShadow: "0px 4px 4px 0px #00000040",
  pb: 2,
  p: 4,
  maxHeight: "75vh",
  overflow: "auto",
  borderRadius: "10px",
  border: 0,
};

const ChangeCategoryModal = ({ open, handleClose, getRequests }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();

  const categories = useSelector((s) => s?.categories?.data);
  const hasMore = useSelector((s) => s?.categories?.hasMore);
  const loadingCategories = useSelector((s) => s?.categories?.loading);

  const getCategories = useCallback(
    ({ next = false }) => {
      getCategoriesAction({ next, limit: 12 })(dispatch);
    },
    [dispatch]
  );

  const onScrolled = (e) => {
    if (loading) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    if (scrollTop + clientHeight + 50 >= scrollHeight && hasMore) {
      getCategories({ next: true });
    }
  };

  useEffect(() => {
    getCategories && getCategories({});
  }, [getCategories]);

  const formik = useFormik({
    initialValues: {
      id: open?.request?.id,
      categoryId: open?.request?.categoryId,
    },
    onSubmit: async (values) => {
      if (loading) return;
      setLoading(true);

      updateRequestAction({
        updatedData: values,
        cb: async (err) => {
          if (!err) {
            await getRequests();
            handleClose();
          }
          setLoading(false);
        },
      })(dispatch);
    },
  });

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={loading}
      >
        <Loader
          height={"50px"}
          style={{ filter: "brightness(0%) invert(100%)" }}
        />
      </Backdrop>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
      >
        <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <Paper sx={style} height={1} width={1}>
            <IconButton
              sx={{
                position: "absolute",
                top: 20,
                right: 20,
                color: "text.primary",
              }}
              onClick={handleClose}
              size="small"
            >
              <CloseIcon size={24} />
            </IconButton>
            <Typography
              textAlign="center"
              variant="h6"
              fontWeight={600}
              sx={{ mb: 4, mt: 2 }}
            >
              Change Category
            </Typography>
            <SelectInput
              label={"Category"}
              placeholder={"Choose Category"}
              name="categoryId"
              formik={formik}
              options={categories}
              renderValue={(option) => option?.id}
              renderOptionLabel={(option) => option?.name}
              loading={loadingCategories}
              MenuProps={{
                PaperProps: {
                  onScroll: onScrolled,
                  sx: { maxHeight: "300px" },
                },
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                sx={{ mt: 4, width: 1, maxWidth: "182px", py: 1 }}
                disabled={loading}
              >
                Save
              </Button>
            </Box>
          </Paper>
        </form>
      </Modal>
    </>
  );
};

export default ChangeCategoryModal;
